// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"587":"615ee4b2","729":"8f890b76"}[chunkId] + ".chunk.js";
};